import Divider from 'components/common/divider';
import { links } from 'constants/external-links';
import { isSsh } from 'components/templates/templates-wizard/url-utils';
import React from 'react';
import type { GitProviderTypes, Tokens } from 'types/api.types';
import type { VCSForm } from 'components/templates/templates-wizard/common/template-wizard.types';
import SshKeysField from 'components/templates/templates-wizard/settings/ssh-keys-field';
import TokenSelectField from 'components/templates/templates-wizard/vcs/token-select-field';
import Link from 'components/common/link';

interface Props {
  gitProvider: GitProviderTypes;
  form: VCSForm;
  tokens: Tokens;
}

export const AuthSection: React.FC<Props> = ({ form, gitProvider, tokens }) => {
  const repository = form.watch('repository');
  const SshKeysFieldLabel = <SshKeysField form={form} />;
  const GitTokenFieldLabel = (
    <>
      <TokenSelectField
        width={49}
        label={{ id: 'templates.add.new.field.token' }}
        data-e2e="token-select-field"
        form={form}
        gitProvider={gitProvider}
        info={{
          id: 'templates.add.new.information.token',
          values: {
            link: (text: string) => <Link plainText messageId={text} url={links.docs.TEMPLATES.TOKENS} />
          }
        }}
        tokens={tokens}
      />
    </>
  );

  return (
    <div data-e2e="authentication-section">
      <Divider data-e2e="authentication-divider" titleId="templates.add.new.divider.authentication" />
      {gitProvider === 'Other' && (isSsh(repository) ? SshKeysFieldLabel : GitTokenFieldLabel)}
    </div>
  );
};
